import GuidelinesContent from './guidelines.content';

export default GuidelinesContent;
